import { Avatar, Input, TextInput } from "@mantine/core";
import "dayjs/locale/tr";
import styled from "styled-components";
import { MagnifyingGlassIcon } from "@heroicons/react/16/solid";
import { theme } from "../../../theme";

const CustomSearchInput = ({
  w = 190,
  h = 44,
  clearable = true,
  withAsterisk = false,
  leftSection,
  ...rest
}: any) => {
  return (
    <StyledInput
      w={w}
      $height={h}
      clearable={clearable}
      withAsterisk={withAsterisk}
      leftSectionPointerEvents="none"
      leftSection={
        leftSection ?? (
          <>
            <MagnifyingGlassIcon
              height={24}
              style={{ color: theme.colors.brand.normal }}
            />
          </>
        )
      }
      {...rest}
    />
  );
};

export default CustomSearchInput;

const StyledInput = styled(TextInput)<{ $height?: number | string }>`
  .mantine-Input-input {
    height: ${({ $height }) => `${$height}px`};
  }
`;
